import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './WerkorderDetail.css';
import WerkorderComments from '../components/WerkorderComments';
import api from '../services/api';
import SubmissionsContextList from '../components/SubmissionsContextList';
import MetingenLijst from '../components/MetingenLijst';
import InhuurNodig from '../components/InhuurNodig';

const WerkorderDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { gebruiker, logout, hasPermission } = useAuth();
  const [werkorder, setWerkorder] = useState(null);
  const [fotos, setFotos] = useState([]);
  const [bijlagen, setBijlagen] = useState([]);
  const [uploadingBijlage, setUploadingBijlage] = useState(false);
  const [checklist, setChecklist] = useState([]);
  const [nieuwPunt, setNieuwPunt] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedFoto, setSelectedFoto] = useState(null);
  const [uploadingFoto, setUploadingFoto] = useState(false);
  const [storingFotos, setStoringFotos] = useState([]);
  const [editingTextItem, setEditingTextItem] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const openPdf = async () => {
    try {
      const r = await api.get(`/werkorders/${id}/pdf`, { responseType: 'blob' });
      const u = URL.createObjectURL(r.data);
      window.open(u, '_blank');
      setTimeout(() => URL.revokeObjectURL(u), 60000);
    } catch (e) { alert('PDF kon niet worden geopend'); }
  };
  const [showDoorsturenModal, setShowDoorsturenModal] = useState(false);
  const [doorsturenAfdeling, setDoorsturenAfdeling] = useState('');
  const [doorsturenReden, setDoorsturenReden] = useState('');
  const [doorsturenLoading, setDoorsturenLoading] = useState(false);

  const handleDoorsturen = async () => {
    if (!doorsturenAfdeling) { alert('Kies een afdeling'); return; }
    setDoorsturenLoading(true);
    try {
      await api.post(`/werkorders/${id}/doorsturen`, {
        naar_afdeling_id: parseInt(doorsturenAfdeling),
        reden: doorsturenReden || null
      });
      const r = await api.get(`/werkorders/${id}`);
      setWerkorder(r.data.werkorder || r.data);
      setShowDoorsturenModal(false);
      setDoorsturenAfdeling('');
      setDoorsturenReden('');
      alert('✅ Werkorder doorgestuurd');
    } catch (e) {
      alert(e.response?.data?.message || 'Fout bij doorsturen');
    } finally {
      setDoorsturenLoading(false);
    }
  };
  const [partijenData, setPartijenData] = useState({ datums: [], partijen: [] });
  const [nieuweDatum, setNieuweDatum] = useState('');
  const [nieuwePartijType, setNieuwePartijType] = useState('afdeling');
  const [nieuwePartijId, setNieuwePartijId] = useState('');
  const [akkoordPartij, setAkkoordPartij] = useState(null);
  const [akkoordDatum, setAkkoordDatum] = useState('');
  const [akkoordMonteurs, setAkkoordMonteurs] = useState([]);
  const [onderaannemers, setOnderaannemers] = useState([]);
  const [duurDagen, setDuurDagen] = useState(1);
  const [aanvangTijd, setAanvangTijd] = useState('');
  const [dienstType, setDienstType] = useState('dag');
  const [overlapInfo, setOverlapInfo] = useState({ overlap: null, alle_binnen: false, in_planning: false });

  const laadPartijen = async () => {
    try {
      const r = await api.get(`/werkorder-partijen/${id}`);
      setPartijenData({ datums: r.data.datums || [], partijen: r.data.partijen || [] });
      setDuurDagen(r.data.duur_dagen || 1);
      setAanvangTijd(r.data.aanvang_tijd || '');
      setDienstType(r.data.dienst_type || 'dag');
      setOverlapInfo({ overlap: r.data.overlap, alle_binnen: r.data.alle_binnen, in_planning: r.data.in_planning });
      try {
        const oa = await api.get('/onderaannemers');
        setOnderaannemers(oa.data.onderaannemers || []);
      } catch (e2) { /* stil */ }
    } catch (e) { /* stil */ }
  };

  const voegDatumToe = async () => {
    if (!nieuweDatum) return;
    const datums = [...partijenData.datums.map(d => d.datum.split('T')[0]), nieuweDatum];
    try {
      await api.post(`/werkorder-partijen/${id}/voorstellen`, { datums });
      setNieuweDatum('');
      laadPartijen();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij opslaan datum'); }
  };

  const [templates, setTemplates] = useState(null);
  const [tplKeuze, setTplKeuze] = useState('');
  const laadTemplates = async () => {
    if (templates) return;
    try {
      const r = await api.get('/checklists/templates');
      const d = r.data;
      setTemplates(Array.isArray(d) ? d : (d.templates || d.data || []));
    } catch (e) { setTemplates([]); }
  };
  const koppelTemplate = async () => {
    if (!tplKeuze) return;
    try {
      await api.put(`/werkorders/${id}/checklist-template`, { template_id: Number(tplKeuze) });
      window.location.reload();
    } catch (e) { alert(e.response?.data?.message || 'Koppelen mislukt'); }
  };
  const voegChecklistPuntToe = async () => {
    const b = nieuwPunt.trim();
    if (!b) return;
    try {
      const r = await api.post(`/werkorders/${id}/checklist`, { beschrijving: b });
      setChecklist([...checklist, r.data.item]);
      setNieuwPunt('');
    } catch (e) { alert(e.response?.data?.message || 'Toevoegen mislukt'); }
  };
  const verwijderChecklistPunt = async (itemId) => {
    if (!window.confirm('Dit checklist-punt verwijderen?')) return;
    try {
      await api.delete(`/werkorders/${id}/checklist/${itemId}`);
      setChecklist(checklist.filter(i => i.id !== itemId));
    } catch (e) { alert(e.response?.data?.message || 'Verwijderen mislukt'); }
  };
  const verwijderDatum = async (weg) => {
    const datums = partijenData.datums.map(d => d.datum.split('T')[0]).filter(d => d !== weg);
    try {
      await api.post(`/werkorder-partijen/${id}/voorstellen`, { datums });
      laadPartijen();
    } catch (e) { alert('Fout bij verwijderen'); }
  };

  const voegPartijToe = async () => {
    if (!nieuwePartijId) { alert('Kies een partij'); return; }
    const body = nieuwePartijType === 'afdeling'
      ? { partij_type: 'afdeling', afdeling_id: parseInt(nieuwePartijId) }
      : { partij_type: 'extern', onderaannemer_id: parseInt(nieuwePartijId) };
    try {
      await api.post(`/werkorder-partijen/${id}/partijen`, body);
      setNieuwePartijId('');
      laadPartijen();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij toevoegen partij'); }
  };

  const verwijderPartij = async (pId) => {
    if (!window.confirm('Partij verwijderen?')) return;
    try { await api.delete(`/werkorder-partijen/partijen/${pId}`); laadPartijen(); }
    catch (e) { alert('Fout bij verwijderen'); }
  };

  const slaDuurOp = async (n) => {
    setDuurDagen(n);
    try { await api.post(`/werkorder-partijen/${id}/voorstellen`, { duur_dagen: n }); } catch (e) {}
  };

  const slaDienstOp = async (dt) => {
    setDienstType(dt);
    try { await api.post(`/werkorder-partijen/${id}/voorstellen`, { dienst_type: dt }); } catch (e) {}
  };

  const slaAanvangOp = async (t) => {
    setAanvangTijd(t);
    try { await api.post(`/werkorder-partijen/${id}/voorstellen`, { aanvang_tijd: t }); } catch (e) {}
  };

  const accepteerTegenvoorstel = async (pId, datum) => {
    if (!window.confirm('Tegenvoorstel accepteren: ' + new Date(datum).toLocaleDateString('nl-NL') + '?')) return;
    try {
      const r = await api.post(`/werkorder-partijen/partijen/${pId}/accepteer`, { datum });
      alert(r.data.message);
      laadPartijen();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij accepteren'); }
  };

  const prikDatum = async (datum) => {
    if (!window.confirm('Definitief plannen op ' + new Date(datum).toLocaleDateString('nl-NL') + '?')) return;
    try {
      const r = await api.post(`/werkorder-partijen/${id}/prik`, { datum });
      alert(r.data.message);
      laadPartijen();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij prikken'); }
  };

  const verstuurVoorstel = async (pId) => {
    try {
      const r = await api.post(`/werkorder-partijen/partijen/${pId}/verstuur`);
      alert(r.data.message);
    } catch (e) { alert(e.response?.data?.message || 'Fout bij versturen'); }
  };

  const geefAkkoord = async () => {
    if (!akkoordDatum) { alert('Kies een datum'); return; }
    try {
      const r = await api.post(`/werkorder-partijen/partijen/${akkoordPartij.id}/akkoord`, {
        gekozen_datum: akkoordDatum,
        monteur_ids: akkoordMonteurs
      });
      alert(r.data.message);
      setAkkoordPartij(null); setAkkoordDatum(''); setAkkoordMonteurs([]);
      laadPartijen();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij akkoord'); }
  };

  const [handtekeningen, setHandtekeningen] = useState([]);
  const [showHandtekeningModal, setShowHandtekeningModal] = useState(false);
  const [handtekeningType, setHandtekeningType] = useState('klant');
  const [handtekeningNaam, setHandtekeningNaam] = useState('');
  const [isDrawing, setIsDrawing] = useState(false);
  const canvasRef = React.useRef(null);
  const [editData, setEditData] = useState({});
  const [afdelingen, setAfdelingen] = useState([]);
  const [alleMonteurs, setAlleMonteurs] = useState([]);

  const startDrawing = (e) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    setIsDrawing(true);
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    e.preventDefault();
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#1a1a1a';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const stopDrawing = () => setIsDrawing(false);

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
  };

  const saveHandtekening = async () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const data = canvas.toDataURL('image/png');
    try {
      await api.post(`/checklists/werkorder/${id}/handtekening`, {
        type: handtekeningType,
        naam: handtekeningNaam,
        handtekening_data: data
      });
      const hRes = await api.get(`/checklists/werkorder/${id}/handtekening`);
      setHandtekeningen(hRes.data.handtekeningen || []);
      setShowHandtekeningModal(false);
      setHandtekeningNaam('');
      clearCanvas();
    } catch(e) { alert('Fout bij opslaan handtekening'); }
  };

  const openEdit = () => {
    setEditData({
      titel: werkorder.titel || '',
      beschrijving: werkorder.beschrijving || '',
      prioriteit: werkorder.prioriteit || 'normaal',
      locatie_adres: werkorder.locatie_adres || '',
      verwachte_uren: werkorder.verwachte_uren || '',
      ordernummer: werkorder.ordernummer || '',
      sap_taak_nummer: werkorder.sap_taak_nummer || '',
      dienst_type: werkorder.dienst_type || 'dag',
      log_optioneel: !!werkorder.log_optioneel,
      afdeling_id: werkorder.afdeling_id || '',
      monteur_ids: werkorder.monteurs ? werkorder.monteurs.map(m => m.id) : (werkorder.toegewezen_aan ? [werkorder.toegewezen_aan] : []),
    });
    setEditMode(true);
  };

  const saveEdit = async () => {
    try {
      await api.put(`/werkorders/${id}`, editData);
      if (Array.isArray(editData.monteur_ids)) {
        await api.put(`/werkorders/${id}/monteurs`, { monteur_ids: editData.monteur_ids });
      }
      setEditMode(false);
      loadWerkorder();
    } catch(e) {
      console.error(e);
      alert('Fout bij opslaan');
    }
  };

  useEffect(() => {
    loadWerkorder();
      laadPartijen();
  }, [id]);
  useEffect(() => {
    const loadDropdowns = async () => {
      try {
        const afdRes = await api.get('/afdelingen');
        setAfdelingen(afdRes.data.afdelingen || afdRes.data || []);
        const monRes = await api.get('/gebruikers');
        const users = monRes.data.gebruikers || monRes.data || [];
        setAlleMonteurs(users.filter(u => u.in_planning));
      } catch (e) { console.error('Fout dropdowns:', e); }
    };
    loadDropdowns();
  }, []);

  const uploadBijlage = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploadingBijlage(true);
    let mislukt = 0;
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append('bijlage', file);
        const r = await api.post(`/werkorders/${id}/bijlagen`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        setBijlagen(prev => [...prev, r.data.bijlage]);
      } catch (err) {
        mislukt++;
        console.error('Bijlage upload fout:', err);
        alert((err.response?.data?.message) || ('Upload mislukt: ' + file.name));
      }
    }
    setUploadingBijlage(false);
    e.target.value = '';
    if (mislukt) alert(mislukt + ' van ' + files.length + ' bestand(en) mislukten');
  };
  const verwijderBijlage = async (bId) => {
    if (!window.confirm('Bijlage verwijderen?')) return;
    try {
      await api.delete(`/werkorders/${id}/bijlagen/${bId}`);
      setBijlagen(prev => prev.filter(b => b.id !== bId));
    } catch (err) {
      alert('Verwijderen mislukt');
    }
  };
  const mailBijlagen = async () => {
    try {
      const r = await api.post(`/werkorders/${id}/bijlagen/mail-mij`);
      alert(r.data.message || 'Verstuurd');
    } catch (err) {
      alert((err.response?.data?.message) || 'Mailen mislukt');
    }
  };
  const loadWerkorder = async () => {
    try {
      const response = await api.get(`/werkorders/${id}`);
      setWerkorder(response.data.werkorder);
      setFotos(response.data.fotos || []);
      setChecklist(response.data.checklist || []);
      try { const sfRes = await api.get(`/werkorders/${id}/storing-fotos`); setStoringFotos(sfRes.data.fotos || []); } catch(e) {}
      try { const hRes = await api.get(`/checklists/werkorder/${id}/handtekening`); setHandtekeningen(hRes.data.handtekeningen || []); } catch(e) {}
      try { const bRes = await api.get(`/werkorders/${id}/bijlagen`); setBijlagen(bRes.data.bijlagen || []); } catch(e) {}
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden werkorder:', error);
      alert('Werkorder niet gevonden');
      navigate('/dashboard');
    }
  };

  const handleChecklistToggle = async (itemId, item) => {
    if (item.type === 'text') {
      // Voor tekstvelden: open edit mode
      setEditingTextItem(itemId);
      return;
    }

    // Voor checkboxes: toggle
    try {
      await api.put(`/werkorders/${id}/checklist/${itemId}`, {
        voltooid: !item.voltooid
      });
      
      setChecklist(checklist.map(i => 
        i.id === itemId 
          ? { ...i, voltooid: !i.voltooid, voltooid_door: gebruiker.id }
          : i
      ));
    } catch (error) {
      alert('Fout bij updaten checklist');
    }
  };

  const handleTextItemSave = async (itemId, waarde) => {
    try {
      await api.put(`/werkorders/${id}/checklist/${itemId}`, {
        voltooid: true,
        waarde: waarde
      });
      
      setChecklist(checklist.map(i => 
        i.id === itemId 
          ? { ...i, voltooid: true, waarde: waarde, voltooid_door: gebruiker.id }
          : i
      ));
      setEditingTextItem(null);
    } catch (error) {
      alert('Fout bij opslaan tekstveld');
    }
  };

  const handleStatusChange = async (newStatus) => {
    if (!window.confirm(`Status wijzigen naar "${newStatus}"?`)) return;

    try {
      await api.put(`/werkorders/${id}`, { status: newStatus });
      setWerkorder({ ...werkorder, status: newStatus });
    } catch (error) {
      alert('Fout bij wijzigen status');
    }
  };

  const handleFotoUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setUploadingFoto(true);
    const nieuweFotos = [];
    let mislukt = 0;
    for (const file of files) {
      try {
        const formData = new FormData();
        formData.append('foto', file);
        const response = await api.post(`/werkorders/${id}/fotos`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        nieuweFotos.push(response.data.foto);
      } catch (error) {
        mislukt++;
      }
    }
    setFotos(prev => [...prev, ...nieuweFotos]);
    setUploadingFoto(false);
    if (e.target) e.target.value = '';
    if (mislukt > 0) alert(mislukt + ' van de ' + files.length + ' fotos mislukten bij uploaden');
  };

  const handleVerwijder = async () => {
    if (!window.confirm('Werkorder definitief verwijderen?\n\nAlle data (checklist, foto\u2019s, comments) gaat ook verloren. Dit kan niet ongedaan worden.')) return;
    try {
      await api.delete('/werkorders/' + id);
      alert('Werkorder verwijderd');
      navigate('/dashboard');
    } catch (err) {
      alert('Fout bij verwijderen: ' + (err.response?.data?.message || err.message));
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      'nieuw': 'badge-nieuw',
      'in_behandeling': 'badge-behandeling',
      'afgerond': 'badge-afgerond'
    };
    return badges[status] || 'badge-default';
  };

  const getStatusText = (status) => {
    const texts = {
      'nieuw': 'Nieuw',
      'in_behandeling': 'In behandeling',
      'afgerond': 'Afgerond'
    };
    return texts[status] || status;
  };

  const getPrioriteitIcon = (prioriteit) => {
    const icons = {
      'laag': '🟢',
      'normaal': '🟡',
      'hoog': '🔴'
    };
    return icons[prioriteit] || '⚪';
  };

  const openMaps = () => {
    if (werkorder.locatie_adres) {
      const encodedAddress = encodeURIComponent(werkorder.locatie_adres);
      window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
    }
  };

  if (loading) {
    return <div className="loading-screen">Laden...</div>;
  }

  if (!werkorder) {
    return <div className="loading-screen">Werkorder niet gevonden</div>;
  }

  const completedItems = checklist.filter(item => item.voltooid).length;
  const totalItems = checklist.length;
  const progress = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;

  return (
    <div className="werkorder-detail">
      <nav className="navbar">
        <div className="navbar-brand">
          <button onClick={() => navigate('/dashboard')} className="btn-back">
            ← Terug
          </button>
          <h2>Werkorder Details</h2>
        </div>
        <div className="navbar-user">
          <span className="user-info">
            {gebruiker?.voornaam} {gebruiker?.achternaam}
          </span>
          <button onClick={logout} className="btn-logout">
            Uitloggen
          </button>
        </div>
      </nav>

      {editMode && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "white", borderRadius: "12px", padding: "32px", width: "560px", maxWidth: "90vw", maxHeight: "90vh", overflowY: "auto" }}>
            <h2 style={{ marginBottom: "24px", fontSize: "18px" }}>✏️ Werkorder bewerken</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>Titel</label>
                <input value={editData.titel} onChange={e => setEditData({...editData, titel: e.target.value})} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>Ordernummer</label>
                <input value={editData.ordernummer} onChange={e => setEditData({...editData, ordernummer: e.target.value})} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>SAP Taak-nummer <span style={{ fontWeight: 400, color: "#6b7280", fontSize: "12px" }}>(optioneel — voor TWI/VOS)</span></label>
                <input value={editData.sap_taak_nummer} onChange={e => setEditData({...editData, sap_taak_nummer: e.target.value})} placeholder="bv. 0042" maxLength={10} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>Dienst</label>
                <div style={{ display: "inline-flex", border: "1px solid #d1d5db", borderRadius: "8px", overflow: "hidden" }}>
                  {["dag", "nacht"].map(dt => (
                    <button key={dt} type="button" onClick={() => setEditData({...editData, dienst_type: dt})}
                      style={{ padding: "8px 18px", border: "none", cursor: "pointer", fontWeight: 600, fontSize: "14px",
                        background: (editData.dienst_type || "dag") === dt ? (dt === "nacht" ? "#4f46e5" : "#10b981") : "#f3f4f6",
                        color: (editData.dienst_type || "dag") === dt ? "#fff" : "#374151" }}>
                      {dt === "nacht" ? "🌙 Nacht" : "☀️ Dag"}
                    </button>
                  ))}
                </div>
                <small style={{ display: "block", marginTop: "4px", color: "#6b7280", fontSize: "12px" }}>Nacht-orders schuiven door naar de volgende monteur in de nachtdienst-rotatie.</small>
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>Beschrijving</label>
                <textarea value={editData.beschrijving} onChange={e => setEditData({...editData, beschrijving: e.target.value})} rows={4} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px", boxSizing: "border-box", resize: "vertical" }} />
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>Prioriteit</label>
                <select value={editData.prioriteit} onChange={e => setEditData({...editData, prioriteit: e.target.value})} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px" }}>
                  <option value="laag">🟢 Laag</option>
                  <option value="normaal">🟡 Normaal</option>
                  <option value="hoog">🟠 Hoog</option>
                  <option value="kritiek">🔴 Kritiek</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>Locatie</label>
                <input value={editData.locatie_adres} onChange={e => setEditData({...editData, locatie_adres: e.target.value})} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px", boxSizing: "border-box" }} />
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>Verwachte uren</label>
                <input type="number" value={editData.verwachte_uren} onChange={e => setEditData({...editData, verwachte_uren: e.target.value})} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px", boxSizing: "border-box" }} />
              </div>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                  <input type="checkbox" checked={!!editData.log_optioneel} onChange={e => setEditData({...editData, log_optioneel: e.target.checked})} style={{ width: "16px", height: "16px" }} />
                  📋 Logboek optioneel bij afmelden
                </label>
                <span style={{ fontSize: "12px", color: "#6b7280", display: "block", marginTop: "2px", marginLeft: "24px" }}>Monteur hoeft geen logboek in te vullen om deze order af te ronden.</span>
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>🏢 Afdeling</label>
                <select value={editData.afdeling_id || ''} onChange={e => setEditData({...editData, afdeling_id: e.target.value ? parseInt(e.target.value) : null})} style={{ width: "100%", padding: "8px 12px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px" }}>
                  <option value="">— Kies afdeling —</option>
                  {afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "4px" }}>👷 Monteurs</label>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "8px", border: "1px solid #d1d5db", borderRadius: "6px", maxHeight: "150px", overflowY: "auto" }}>
                  {alleMonteurs.length === 0 && <span style={{ fontSize: "12px", color: "#9ca3af" }}>Geen monteurs gevonden</span>}
                  {alleMonteurs.map(m => (
                    <label key={m.id} style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", cursor: "pointer" }}>
                      <input type="checkbox" checked={(editData.monteur_ids || []).includes(m.id)} onChange={e => {
                        const ids = editData.monteur_ids || [];
                        setEditData({...editData, monteur_ids: e.target.checked ? [...ids, m.id] : ids.filter(x => x !== m.id)});
                      }} />
                      <span>{m.voornaam} {m.achternaam}{m.afdeling_id ? '' : ' ⚠️ geen afdeling'}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ marginTop: "16px" }}>
              <label style={{ fontSize: "13px", fontWeight: 600, color: "#374151", display: "block", marginBottom: "8px" }}>📸 Foto toevoegen</label>
              <input type="file" accept="image/*" multiple onChange={handleFotoUpload} disabled={uploadingFoto} style={{ width: "100%", padding: "8px", border: "2px dashed #d1d5db", borderRadius: "6px", cursor: "pointer" }} />
              {uploadingFoto && <p style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>Uploaden...</p>}
            </div>
            <div style={{ display: "flex", gap: "10px", marginTop: "24px", justifyContent: "flex-end" }}>
              <button onClick={() => setEditMode(false)} style={{ padding: "10px 20px", background: "#f3f4f6", border: "1px solid #d1d5db", borderRadius: "6px", cursor: "pointer", fontSize: "14px" }}>Annuleren</button>
              <button onClick={saveEdit} style={{ padding: "10px 20px", background: "#3b82f6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "14px", fontWeight: 600 }}>💾 Opslaan</button>
            </div>
          </div>
        </div>
      )}
      <div className="detail-container">
        <div className="detail-header">
          <div className="header-main">
      <h1>{getPrioriteitIcon(werkorder.prioriteit)} {werkorder.titel}{werkorder.oa_afgemeld_door && <span title="Uitgevoerd door onderaannemer" style={{ marginLeft: 8, fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 999, background: '#fef3c7', color: '#92400e', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>🤝 {werkorder.oa_afgemeld_door}{werkorder.status !== 'afgerond' && werkorder.oa_gereed_op ? ' · gereed gemeld, te controleren' : ''}</span>}</h1>
            {werkorder.ordernummer && <div style={{ fontSize: "14px", color: "#6b7280", marginTop: "4px" }}>Ordernr: <strong>{werkorder.ordernummer}</strong></div>}
            <span className={`badge ${getStatusBadge(werkorder.status)}`}>
              {getStatusText(werkorder.status)}
            </span>
          </div>
          
          <div className="status-actions">
            <label>Status wijzigen:</label>
            <div className="status-buttons">
              <button 
                onClick={() => handleStatusChange('nieuw')}
                className={`btn-status ${werkorder.status === 'nieuw' ? 'active' : ''}`}
                disabled={werkorder.status === 'nieuw'}
              >
                🆕 Nieuw
              </button>
              <button 
                onClick={() => handleStatusChange('in_behandeling')}
                className={`btn-status ${werkorder.status === 'in_behandeling' ? 'active' : ''}`}
                disabled={werkorder.status === 'in_behandeling'}
              >
                🔧 In behandeling
              </button>
              <button 
                onClick={() => handleStatusChange('afgerond')}
                className={`btn-status ${werkorder.status === 'afgerond' ? 'active' : ''}`}
                disabled={werkorder.status === 'afgerond'}
              >
                ✅ Afgerond
              </button>
            </div>
            <div style={{ display: "flex", gap: "8px", marginTop: "12px", flexWrap: "wrap" }}>
              <button onClick={openEdit} style={{ padding: "10px 16px", background: "#f59e0b", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: 500 }}>✏️ Bewerken</button>
              {hasPermission('werkorders:doorsturen') && werkorder.status !== 'afgerond' && (
                <button onClick={() => setShowDoorsturenModal(true)} style={{ padding: "10px 16px", background: "#8b5cf6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: 500 }}>📤 Doorsturen</button>
              )}
              <button onClick={openPdf} style={{ padding: "10px 16px", background: "#059669", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: 500 }}>📄 Export PDF</button>
              <button onClick={openPdf} style={{ padding: "10px 16px", background: "#3b82f6", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: 500 }}>🖨️ Print</button>
              <button onClick={handleVerwijder} style={{ padding: "10px 16px", background: "#ef4444", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: 500 }}>🗑️ Verwijderen</button>
            </div>
          </div>
        </div>

        <div className="detail-grid">
          <div className="detail-main">
            <div className="info-card">
              <h3>📝 Beschrijving</h3>
               <p style={{ whiteSpace: 'pre-line' }}>{werkorder.beschrijving || 'Geen beschrijving'}</p>
            </div>

            <div className="info-card">
              <h3>ℹ️ Informatie</h3>
              <div className="info-rows">
                {werkorder.ordernummer && (
                  <div className="info-row">
                    <span className="info-label">Ordernummer:</span>
                    <span><strong>{werkorder.ordernummer}</strong></span>
                  </div>
                )}
                <div className="info-row">              
                 <span className="info-label">Afdeling:</span>
                  <span>{werkorder.afdeling_naam}</span>
                </div>
                {werkorder.oorspronkelijke_afdeling_id && (
                  <>
                    <div className="info-row" style={{ background: '#fef3c7', padding: '4px 8px', borderRadius: 4 }}>
                      <span className="info-label">📤 Doorgestuurd van:</span>
                      <span>{werkorder.oorspronkelijke_afdeling_naam || `afd ${werkorder.oorspronkelijke_afdeling_id}`}{werkorder.doorgestuurd_op && ` op ${new Date(werkorder.doorgestuurd_op).toLocaleDateString('nl-NL')}`}</span>
                    </div>
                    {werkorder.doorstuur_reden && (
                      <div className="info-row" style={{ background: '#fef3c7', padding: '4px 8px', borderRadius: 4 }}>
                        <span className="info-label">Reden:</span>
                        <span>{werkorder.doorstuur_reden}</span>
                      </div>
                    )}
                  </>
                )}
                <div className="info-row">
                  <span className="info-label">Prioriteit:</span>
                  <span>{getPrioriteitIcon(werkorder.prioriteit)} {werkorder.prioriteit}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Aangemaakt door:</span>
                  <span>{werkorder.aangemaakt_door_voornaam} {werkorder.aangemaakt_door_achternaam}</span>
                </div>
                {werkorder.toegewezen_aan_voornaam && (
                  <div className="info-row">
                    <span className="info-label">Toegewezen aan:</span>
                    <span>👤 {werkorder.toegewezen_aan_voornaam} {werkorder.toegewezen_aan_achternaam}</span>
                  </div>
                )}
                <div className="info-row">
                  <span className="info-label">Aangemaakt op:</span>
                  <span>{new Date(werkorder.created_at).toLocaleString('nl-NL')}</span>
                </div>
                {werkorder.afgerond_op && (
                  <div className="info-row">
                    <span className="info-label">Afgerond op:</span>
                    <span>{new Date(werkorder.afgerond_op).toLocaleString('nl-NL')}</span>
                  </div>
                )}

              </div>
            </div>

            {werkorder.klant_id && (
              <div className="info-card">
                <h3>🏢 Klant</h3>
                <p onClick={() => navigate(`/klant/${werkorder.klant_id}`)}
                  style={{ color: '#2563eb', cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}>
                  {werkorder.klant_naam || 'Klant bekijken'}
                </p>
              </div>
            )}
            {werkorder.locatie_adres && (
              <div className="info-card">
                <h3>📍 Locatie</h3>
                <p>{werkorder.locatie_adres}</p>
                <button onClick={openMaps} className="btn-maps">
                  🗺️ Open in Google Maps
                </button>
              </div>
            )}

            {checklist.length === 0 && (
              <div className="info-card">
                <div className="checklist-header"><h3>✅ Checklist</h3></div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', margin: '6px 0' }}>
                  <select value={tplKeuze} onFocus={laadTemplates} onChange={e => setTplKeuze(e.target.value)} style={{ flex: 1, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, background: 'white' }}>
                    <option value="">☑ Template kiezen...</option>
                    {(templates || []).map(t => <option key={t.id} value={t.id}>{t.naam}</option>)}
                  </select>
                  <button onClick={koppelTemplate} disabled={!tplKeuze} className="btn-primary" style={{ whiteSpace: 'nowrap', opacity: tplKeuze ? 1 : 0.5 }}>Koppelen</button>
                </div>
                <p style={{ color: '#6b7280', fontSize: 13, margin: '6px 0' }}>Of voeg losse controlepunten toe:</p>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input type="text" value={nieuwPunt} onChange={e => setNieuwPunt(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') voegChecklistPuntToe(); }} placeholder="Nieuw controlepunt..." style={{ flex: 1, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8 }} />
                  <button onClick={voegChecklistPuntToe} className="btn-primary" style={{ whiteSpace: 'nowrap' }}>+ Punt</button>
                </div>
              </div>
            )}
            {checklist.length > 0 && (
              <div className="info-card">
                <div className="checklist-header">
                  <h3>✅ Checklist</h3>
                  <span className="checklist-progress">
                    {completedItems}/{totalItems} ({progress}%)
                  </span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                </div>
                <div style={{ display: 'flex', gap: 8, margin: '10px 0' }}>
                  <input type="text" value={nieuwPunt} onChange={e => setNieuwPunt(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') voegChecklistPuntToe(); }} placeholder="Nieuw controlepunt..." style={{ flex: 1, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8 }} />
                  <button onClick={voegChecklistPuntToe} className="btn-primary" style={{ whiteSpace: 'nowrap' }}>+ Punt</button>
                </div>
                <div className="checklist-items">
                  {checklist.map(item => (
                    <div key={item.id} className="checklist-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #eee' }}>
                      <span style={{ flex: 1 }}>{item.beschrijving}</span>
                      <button onClick={() => verwijderChecklistPunt(item.id)} title="Punt verwijderen" style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#dc2626', marginRight: 8 }}>🗑</button>
                      {item.waarde ? (
                        <span style={{
                          padding: '4px 12px',
                          borderRadius: '4px',
                          fontWeight: '600',
                          fontSize: '14px',
                          marginLeft: '10px',
                          background: item.waarde === 'goed' ? '#10b981' : item.waarde === 'fout' ? '#ef4444' : item.waarde === 'nvt' ? '#9ca3af' : '#3b82f6',
                          color: 'white'
                        }}>
                          {item.waarde === 'goed' ? '✓ Goed' : item.waarde === 'fout' ? '✗ Fout' : item.waarde === 'nvt' ? '− N.v.t.' : item.waarde}
                        </span>
                      ) : item.voltooid ? (
                        <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                      ) : (
                        <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>−</span>
                      )}
                    </div>
                  ))}

                </div>
              </div>
            )}
            {storingFotos.length > 0 && (
              <div className="info-card">
                <h3>🚨 Storing Fotos ({storingFotos.length})</h3>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: "10px", marginTop: "12px" }}>
                  {storingFotos.map((foto, i) => (
                    <div key={foto.id} style={{ borderRadius: "8px", overflow: "hidden", border: "2px solid #fca5a5", aspectRatio: "1", position: "relative" }}>
                      <img src={foto.url || `/uploads/storingen/${foto.bestand_naam}`} alt={`Storing ${i+1}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "rgba(220,38,38,0.8)", color: "white", fontSize: "11px", padding: "4px 8px" }}>🚨 {foto.voornaam} {foto.achternaam}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* Afmeld opmerking sectie */}
            {werkorder.afmeld_opmerking && (
              <div className="info-card" style={{ background: '#fefce8', border: '1px solid #fde047' }}>
                <h3 style={{ color: '#854d0e' }}>💬 Opmerking bij afmelden</h3>
                <p style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{werkorder.afmeld_opmerking}</p>
              </div>
            )}

            {/* Forms sectie */}
            {werkorder?.id && (
              <div style={{ marginTop: 24, padding: 16, background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0' }}>
                <h3 style={{ marginTop: 0 }}>📋 Formulieren</h3>
                <SubmissionsContextList werkorderId={werkorder.id} />
                <MetingenLijst werkorderId={werkorder.id} />
                {werkorder.status !== 'afgerond' && <InhuurNodig werkorderId={werkorder.id} />}
              </div>
            )}
            {/* Fotos sectie */}
            {fotos.length > 0 && (
              <div className="info-card">
                <h3>📸 Foto's ({fotos.length})</h3>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: "10px", marginTop: "12px" }}>
                  {fotos.map((foto, i) => (
                    <div key={foto.id} onClick={() => setSelectedFoto(foto)} style={{ cursor: "pointer", borderRadius: "8px", overflow: "hidden", border: "2px solid #e5e7eb", aspectRatio: "1", position: "relative" }}>
                      <img src={foto.url || `/uploads/werkorders/${foto.bestand_naam}`} alt={`Foto ${i+1}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "rgba(0,0,0,0.6)", color: "white", fontSize: "11px", padding: "4px 8px" }}>{foto.voornaam} {foto.achternaam}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {hasPermission && hasPermission('werkorders:partijen') && (
              <div className="info-card">
                <h3>🤝 Partijen & datumvoorstel{/* woDicht */}</h3>
                <div style={{ marginBottom: '14px', display: werkorder.status === 'afgerond' ? 'none' : 'block' }}>
                  <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Voorsteldatums</div>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    {partijenData.datums.map(d => (
                      <span key={d.id} style={{ background: '#eef2ff', borderRadius: '8px', padding: '6px 10px', fontSize: '13px' }}>
                        {new Date(d.datum).toLocaleDateString('nl-NL')}
                        <button onClick={() => verwijderDatum(d.datum.split('T')[0])} style={{ marginLeft: '6px', border: 'none', background: 'none', cursor: 'pointer', color: '#dc2626' }}>×</button>
                      </span>
                    ))}
                    <input type="date" value={nieuweDatum} onChange={e => setNieuweDatum(e.target.value)} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db' }} />
                    <button onClick={voegDatumToe} style={{ background: '#00D4AA', color: '#fff', border: 'none', borderRadius: '8px', padding: '7px 12px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>+ Datum</button>
                    <span style={{ fontSize: '13px', marginLeft: '10px' }}>Duur:</span>
                    <input type="number" min="1" max="30" value={duurDagen} onChange={e => slaDuurOp(Math.max(1, parseInt(e.target.value) || 1))} style={{ width: '52px', padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db' }} />
                    <span style={{ fontSize: '13px' }}>{duurDagen === 1 ? 'dag' : 'dagen'}</span>
                    <select value={dienstType} onChange={e => slaDienstOp(e.target.value)} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px', marginLeft: '10px' }}>
                      <option value="dag">☀️ Dag</option>
                      <option value="nacht">🌙 Nacht</option>
                    </select>
                    <span style={{ fontSize: '13px', marginLeft: '10px' }}>Aanvang:</span>
                    <select value={(aanvangTijd || '').split(':')[0] || ''} onChange={e => slaAanvangOp(e.target.value === '' ? '' : e.target.value + ':' + ((aanvangTijd || '').split(':')[1] || '00'))} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }}>
                      <option value="">--</option>
                      {Array.from({length: 24}, (_, i) => String(i).padStart(2, '0')).map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                    <span style={{ fontSize: '13px' }}>:</span>
                    <select value={(aanvangTijd || '').split(':')[1] || '00'} onChange={e => { const u = (aanvangTijd || '').split(':')[0]; if (u) slaAanvangOp(u + ':' + e.target.value); }} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }}>
                      {['00','15','30','45'].map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                  </div>
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Partijen</div>
                  {partijenData.partijen.length === 0 && <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px' }}>Nog geen partijen gekoppeld.</div>}
                  {partijenData.partijen.map(p => (
                    <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: '#f8f9fa', borderRadius: '8px', marginBottom: '6px' }}>
                      <div style={{ fontSize: '13px' }}>
                        <strong>{p.partij_type === 'afdeling' ? p.afdeling_naam : (p.onderaannemer_naam || p.gebruiker_naam)}</strong>
                        {' '}
                        {p.status === 'akkoord'
                          ? <span style={{ color: '#059669' }}>✅ {p.partij_type === 'extern' && !p.gekozen_datum ? 'kan op: ' + (p.beschikbaar || []).map(d => new Date(d).toLocaleDateString('nl-NL')).join(', ') : (p.gekozen_datum ? new Date(p.gekozen_datum).toLocaleDateString('nl-NL') : 'akkoord')} {p.akkoord_door_naam ? '• ' + p.akkoord_door_naam : (p.partij_type === 'extern' ? '• via mail-link' : '')}</span>
                          : p.status === 'tegenvoorstel' ? <span style={{ color: '#d97706' }}>📅 tegenvoorstel:{' '}
                            {(p.beschikbaar || []).map(d => (
                              <button key={d} onClick={() => accepteerTegenvoorstel(p.id, d)} title="Accepteer deze datum"
                                style={{ background: '#d97706', color: '#fff', border: 'none', borderRadius: '6px', padding: '3px 8px', fontSize: '12px', fontWeight: 600, cursor: 'pointer', marginRight: '4px' }}>
                                {new Date(d).toLocaleDateString('nl-NL')} ✓
                              </button>
                            ))}</span> : p.status === 'afgerond' ? <span style={{ color: '#059669', fontWeight: 600 }}>✅ afgemeld{p.afgemeld_op ? ' op ' + new Date(p.afgemeld_op).toLocaleDateString('nl-NL') : ''}{p.afmeld_verslag ? <span style={{ display: 'block', fontWeight: 400, color: '#374151', marginTop: 4, whiteSpace: 'pre-wrap' }}>{p.afmeld_verslag}</span> : null}</span> : p.status === 'afgewezen' ? <span style={{ color: '#dc2626' }}>❌ afgewezen — datums passen niet</span> : <span style={{ color: '#d97706' }}>⏳ wacht op akkoord{p.partij_type === 'extern' && !p.verstuurd_op && <span style={{ marginLeft: '8px', background: '#f59e0b', color: '#fff', borderRadius: '8px', padding: '2px 8px', fontSize: '11px', fontWeight: 700 }}>📧 nog niet verstuurd</span>}{p.partij_type === 'extern' && p.verstuurd_op && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#6b7280' }}>verstuurd {new Date(p.verstuurd_op).toLocaleDateString('nl-NL')}</span>}</span>}
                      </div>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        {p.status !== 'akkoord' && p.partij_type === 'extern' && (
                          <button onClick={() => verstuurVoorstel(p.id)} style={{ display: werkorder.status === 'afgerond' ? 'none' : 'inline-block', background: '#00D4AA', color: '#fff', border: 'none', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>{p.verstuurd_op ? '📧 Opnieuw' : '📧 Verstuur'}</button>
                        )}
                        {p.status !== 'akkoord' && p.partij_type === 'afdeling' && (
                          <button onClick={() => { setAkkoordPartij(p); setAkkoordDatum(''); setAkkoordMonteurs([]); }} style={{ background: '#059669', color: '#fff', border: 'none', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>Akkoord</button>
                        )}
                        <button onClick={() => verwijderPartij(p.id)} style={{ display: werkorder.status === 'afgerond' ? 'none' : 'inline-block', background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: '6px', padding: '5px 8px', fontSize: '12px', cursor: 'pointer' }}>×</button>
                      </div>
                    </div>
                  ))}
                  <div style={{ display: werkorder.status === 'afgerond' ? 'none' : 'flex', gap: '8px', marginTop: '8px' }}>
                    <select value={nieuwePartijType} onChange={e => { setNieuwePartijType(e.target.value); setNieuwePartijId(''); }} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }}>
                      <option value="afdeling">Afdeling</option>
                      <option value="extern">Onderaannemer</option>
                    </select>
                    <select value={nieuwePartijId} onChange={e => setNieuwePartijId(e.target.value)} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px', minWidth: '180px' }}>
                      <option value="">— kies —</option>
                      {nieuwePartijType === 'afdeling'
                        ? afdelingen.map(af => <option key={af.id} value={af.id}>{af.naam}</option>)
                        : onderaannemers.map(o => <option key={o.id} value={o.id}>{o.naam}</option>)}
                    </select>
                    <button onClick={voegPartijToe} style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '8px', padding: '7px 12px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>+ Partij</button>
                  </div>
                </div>
                {overlapInfo.alle_binnen && !overlapInfo.in_planning && (
                  <div style={{ background: overlapInfo.overlap && overlapInfo.overlap.length ? '#eff6ff' : '#fef2f2', border: '1px solid ' + (overlapInfo.overlap && overlapInfo.overlap.length ? '#93c5fd' : '#fca5a5'), borderRadius: '10px', padding: '12px', marginBottom: '12px' }}>
                    {overlapInfo.overlap && overlapInfo.overlap.length > 0 ? (
                      <>
                        <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>📌 Alle partijen binnen — gezamenlijke datums, prik de definitieve:</div>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                          {overlapInfo.overlap.map(d => (
                            <button key={d} onClick={() => prikDatum(d)} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 14px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>{new Date(d).toLocaleDateString('nl-NL')}</button>
                          ))}
                        </div>
                      </>
                    ) : (
                      <div style={{ fontWeight: 600, fontSize: '14px', color: '#dc2626' }}>⚠️ Geen gezamenlijke datum — voeg nieuwe voorsteldatums toe en verstuur opnieuw, of overleg telefonisch.</div>
                    )}
                  </div>
                )}
                {overlapInfo.in_planning && (
                  <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '10px', padding: '10px 12px', marginBottom: '12px', fontSize: '14px', fontWeight: 600, color: '#059669' }}>✅ Definitief ingepland</div>
                )}
                {akkoordPartij && (
                  <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '10px', padding: '12px' }}>
                    <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '8px' }}>Akkoord: {akkoordPartij.afdeling_naam}</div>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
                      {partijenData.datums.map(d => {
                        const dv = d.datum.split('T')[0];
                        return <button key={d.id} onClick={() => setAkkoordDatum(dv)} style={{ background: akkoordDatum === dv ? '#059669' : '#fff', color: akkoordDatum === dv ? '#fff' : '#111827', border: '1px solid #059669', borderRadius: '8px', padding: '6px 12px', fontSize: '13px', cursor: 'pointer', fontWeight: 600 }}>{new Date(d.datum).toLocaleDateString('nl-NL')}</button>;
                      })}
                    </div>
                    {akkoordPartij.partij_type === 'afdeling' && (
                      <div style={{ marginBottom: '8px' }}>
                        <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Monteur(s)</div>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                          {alleMonteurs.filter(g => g.afdeling_id == akkoordPartij.afdeling_id).map(g => (
                            <label key={g.id} style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <input type="checkbox" checked={akkoordMonteurs.includes(g.id)} onChange={e => setAkkoordMonteurs(prev => e.target.checked ? [...prev, g.id] : prev.filter(x => x !== g.id))} />
                              {g.voornaam} {g.achternaam}
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={geefAkkoord} style={{ background: '#059669', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 14px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>✅ Bevestig akkoord</button>
                      <button onClick={() => setAkkoordPartij(null)} style={{ background: '#f3f4f6', border: 'none', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer', fontSize: '13px' }}>Annuleren</button>
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* Bijlagen sectie (tekeningen/software) */}
            <div className="info-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>📎 Bijlagen ({bijlagen.length})</h3>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {bijlagen.length > 0 && (
                    <button onClick={mailBijlagen} style={{ background: '#00D4AA', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 14px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>✉️ Mail mij</button>
                  )}
                  <label style={{ background: '#111827', color: '#fff', borderRadius: '8px', padding: '8px 14px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>
                    {uploadingBijlage ? 'Bezig…' : '+ Bestand'}
                    <input type="file" multiple onChange={uploadBijlage} disabled={uploadingBijlage} style={{ display: 'none' }} />
                  </label>
                </div>
              </div>
              {bijlagen.length === 0 ? (
                <p style={{ color: '#94a3b8', fontSize: '13px', margin: '10px 0 0' }}>Nog geen bijlagen. Voeg tekeningen of software toe.</p>
              ) : (
                <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {bijlagen.map(b => (
                    <div key={b.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px 12px' }}>
                      <div style={{ overflow: 'hidden' }}>
                        <div style={{ fontWeight: 600, fontSize: '14px', color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{b.originele_naam}</div>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>{b.grootte ? (b.grootte/1024/1024).toFixed(2) + ' MB' : ''}{b.voornaam ? ' · ' + b.voornaam + ' ' + (b.achternaam||'') : ''}</div>
                      </div>
                      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                        <a href={b.url || `/uploads/werkorder-bijlagen/${b.bestand_naam}`} download={b.originele_naam} style={{ background: '#f1f5f9', color: '#1e293b', borderRadius: '6px', padding: '6px 12px', fontSize: '13px', textDecoration: 'none', fontWeight: 600 }}>⬇️</a>
                        <button onClick={() => verwijderBijlage(b.id)} style={{ background: '#fef2f2', color: '#ef4444', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '13px', cursor: 'pointer', fontWeight: 600 }}>✕</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Handtekeningen sectie */}
            {handtekeningen.length > 0 && (
              <div className="info-card">
                <h3>✍️ Handtekeningen</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '16px', marginTop: '12px' }}>
                  {handtekeningen.map((ht, i) => (
                    <div key={i} style={{ border: '2px solid #e5e7eb', borderRadius: '12px', padding: '12px', background: '#fafafa' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={{ fontWeight: '600', fontSize: '14px', color: '#1e293b' }}>
                          {ht.type === 'monteur' ? '👷 Monteur' : '👤 Klant'}
                        </span>
                        <span style={{ fontSize: '12px', color: '#64748b' }}>
                          {ht.getekend_op ? new Date(ht.getekend_op).toLocaleString('nl-NL') : ''}
                        </span>
                      </div>
                      {ht.naam && <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#64748b' }}>{ht.naam}</p>}
                      {ht.handtekening_data && (
                        <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '8px' }}>
                          <img src={ht.handtekening_data} alt={ht.type + ' handtekening'} style={{ width: '100%', height: '80px', objectFit: 'contain' }} />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {selectedFoto && (
        <div className="foto-lightbox" onClick={() => setSelectedFoto(null)}>
          <div className="lightbox-content">
            <button className="btn-close-lightbox" onClick={() => setSelectedFoto(null)}>×</button>
            <img 
              src={selectedFoto.url || `/uploads/werkorders/${selectedFoto.bestand_naam}`} 
              alt={selectedFoto.bestand_naam}
            />
            <div className="foto-info">
              <p>Geüpload door: {selectedFoto.voornaam} {selectedFoto.achternaam}</p>
              <p>{new Date(selectedFoto.created_at).toLocaleString('nl-NL')}</p>
            </div>
          </div>
        </div>
      )}
      {/* Doorsturen modal */}
      {showDoorsturenModal && (
        <div onClick={() => !doorsturenLoading && setShowDoorsturenModal(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: 'white', padding: 24, borderRadius: 8, minWidth: 400, maxWidth: 500, width: '90%' }}>
            <h2 style={{ marginTop: 0 }}>📤 Werkorder doorsturen</h2>
            <p style={{ color: '#64748b', fontSize: 14, marginTop: 4 }}>Naar welke afdeling moet deze werkorder?</p>
            <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>Afdeling</label>
            <select value={doorsturenAfdeling} onChange={e => setDoorsturenAfdeling(e.target.value)} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, marginBottom: 16, boxSizing: 'border-box' }}>
              <option value="">— Kies afdeling —</option>
              {afdelingen.filter(a => a.id !== werkorder.afdeling_id).map(a => (
                <option key={a.id} value={a.id}>{a.naam}</option>
              ))}
            </select>
            <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>Reden (optioneel)</label>
            <textarea value={doorsturenReden} onChange={e => setDoorsturenReden(e.target.value)} placeholder="Bijv. Past beter bij andere afdeling..." style={{ width: '100%', padding: 8, border: '1px solid #d1d5db', borderRadius: 6, minHeight: 80, marginBottom: 16, boxSizing: 'border-box', fontFamily: 'inherit' }} />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowDoorsturenModal(false)} disabled={doorsturenLoading} style={{ padding: '8px 16px', background: '#e5e7eb', border: 'none', borderRadius: 6, cursor: 'pointer' }}>Annuleren</button>
              <button onClick={handleDoorsturen} disabled={doorsturenLoading || !doorsturenAfdeling} style={{ padding: '8px 16px', background: '#8b5cf6', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', opacity: (doorsturenLoading || !doorsturenAfdeling) ? 0.6 : 1 }}>
                {doorsturenLoading ? '⏳ Bezig...' : '📤 Doorsturen'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WerkorderDetail;
